import Div from 'src/components/atomic/atom/Div'
import Span from 'src/components/atomic/atom/Span'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { COLOR } from 'src/constants/colors'
const StopWatch = () => {
  const { callTime } = useAppSelector((state: RootState) => state.CameraPage)
  return (
    <Div
      width={'120px'}
      height={'32px'}
      $position={'absolute'}
      $border_radius={'20px'}
      $bgColor={COLOR.blackOpacity06}
      style={{
        bottom: '76px',
        left: '50%',
        transform: 'translateX(-50%)',
      }}
    >
      <Span option={'small_bold'} color={'white'} $text_align={'center'} $line_height={'32px'}>
        {callTime.text}
      </Span>
    </Div>
  )
}

export default StopWatch
